import "./App.css";
import React, { useState } from "react";
import Home from "./Home";
import Category from "./Category";
import BotList from "./BotList";
import NewBot from "./NewBot";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>

          <Route exact path="/category">
            <Category />
          </Route>

          <Route exact path="/new">
            <NewBot />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
